import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import Typography from '@mui/material/Typography';

const PaperComponent: React.FC<PaperProps> = props => {
  const nodeRef = useRef(null);
  return (
    <Draggable nodeRef={nodeRef} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

const StyledDialogTitle = styled(DialogTitle)`
  cursor: move;
  display: flex;
  justify-content: space-between;

  && {
    padding-bottom: 0;
  }
`;

const StyledDialog = styled(Dialog)<{ $alignTop: boolean }>`
  .MuiPaper-root.MuiDialog-paper {
    background-color: #f5f5f5;
    border: 6px solid #95bcd7;
  }

  .MuiDialog-scrollPaper {
    ${props => props.$alignTop && 'align-items: flex-start'}
  }
`;

const TitleActions = styled('span')`
  display: flex;
  gap: 15px;

  > * {
    cursor: pointer;
  }
`;

export interface DraggableDialogProps extends DialogProps {
  id: string;
  title: string;
  alignTop?: boolean;
  actions?: React.ReactNode;
}

export const DraggableDialog: React.FC<DraggableDialogProps> = ({
  children,
  id,
  title,
  actions,
  alignTop = false,
  ...props
}) => (
  <StyledDialog
    PaperComponent={PaperComponent}
    aria-labelledby={`${id}-title`}
    $alignTop={alignTop}
    {...props}
  >
    <StyledDialogTitle>
      <Typography id={`${id}-title`} variant="h5" component="h2">
        {title}
      </Typography>
      {actions && <TitleActions>{actions}</TitleActions>}
    </StyledDialogTitle>
    {children}
  </StyledDialog>
);
